<div
  class="default-prompt min-h-40 sm:min-h-auto border border-solid border-[#CBD5E1] rounded-xl h-[8.1875rem] p-6 bg-white shadow-[4px_4px_9px_2px_rgba(0,94,184,0.20)] cursor-pointer"
  (click)="selectPrompt(prompt.prompt)"
>
  <h3 class="flex items-center text-sm font-bold m-0">
    <i #promptIcon class="mr-2"></i>
    {{ prompt.title | translate }}
  </h3>
  <p class="prompt-suggestion mt-1" [innerHTML]="prompt.prompt | translate"></p>
</div>
